import { Link } from "react-router-dom";
import { Beef, ArrowLeft, ShieldCheck } from "lucide-react";

export default function Privacy() {
  return (
    <div className="min-h-screen grain relative z-10 py-10 px-4">
      <div className="max-w-3xl mx-auto">
        <Link to="/" className="inline-flex items-center gap-2 text-zinc-400 hover:text-white text-sm mb-6">
          <ArrowLeft className="w-4 h-4" /> Voltar
        </Link>
        <div className="flex items-center gap-2 mb-6">
          <div className="w-10 h-10 rounded-xl bg-red-600 flex items-center justify-center"><Beef className="w-5 h-5 text-white" /></div>
          <span className="font-display font-extrabold text-xl">CarnesWork</span>
        </div>
        <div className="cw-card p-8 sm:p-10">
          <div className="flex items-center gap-2 mb-2">
            <ShieldCheck className="w-6 h-6 text-emerald-400" />
            <h1 className="text-3xl font-display font-extrabold">Política de Privacidade</h1>
          </div>
          <p className="text-xs text-zinc-500 mb-6">Última atualização: 25 de setembro de 2026 · Em conformidade com a LGPD (Lei 13.709/2018)</p>

          <section className="space-y-4 text-zinc-300 text-sm leading-relaxed">
            <div>
              <h2 className="text-lg font-bold text-white mb-2">1. Controlador de Dados</h2>
              <p>CarnesWork · Responsável: Edinaldo Alves da Silva · Contato: <a className="text-red-500" href="mailto:edinaldoalvesdasilva8@gmail.com">edinaldoalvesdasilva8@gmail.com</a></p>
            </div>

            <div>
              <h2 className="text-lg font-bold text-white mb-2">2. Dados que Coletamos</h2>
              <ul className="list-disc pl-5 space-y-1">
                <li><strong>Identificação:</strong> nome, email, telefone, CPF (profissional) ou CNPJ (comércio)</li>
                <li><strong>Localização:</strong> cidade e coordenadas aproximadas (com seu consentimento) para exibir diárias próximas</li>
                <li><strong>Uso do serviço:</strong> diárias publicadas/aceitas, mensagens no chat, avaliações, pontos, pagamentos processados</li>
                <li><strong>Técnicos:</strong> logs de acesso, cookies de sessão (autenticação)</li>
              </ul>
            </div>

            <div>
              <h2 className="text-lg font-bold text-white mb-2">3. Finalidade do Tratamento</h2>
              <p>Usamos seus dados para: (i) permitir cadastro e autenticação; (ii) casar comércios e profissionais; (iii) processar pagamentos via Stripe; (iv) enviar notificações relevantes de vagas; (v) prevenir fraude; (vi) cumprir obrigações legais.</p>
            </div>

            <div>
              <h2 className="text-lg font-bold text-white mb-2">4. Base Legal (LGPD Art. 7º)</h2>
              <p>Consentimento (você aceita ao se cadastrar), execução de contrato, cumprimento de obrigação legal e legítimo interesse (segurança e prevenção de fraude).</p>
            </div>

            <div>
              <h2 className="text-lg font-bold text-white mb-2">5. Compartilhamento</h2>
              <p>Compartilhamos apenas o necessário com: <strong>Stripe</strong> (processamento de pagamentos), <strong>Resend</strong> (envio de emails transacionais), <strong>MongoDB</strong> (armazenamento). Não vendemos dados a terceiros. Dados exibidos publicamente: seu nome, cidade, avaliação e ranking.</p>
            </div>

            <div>
              <h2 className="text-lg font-bold text-white mb-2">6. Armazenamento</h2>
              <p>Dados ficam em servidores seguros. Senhas são armazenadas apenas em hash bcrypt (não podemos vê-las). Retemos os dados enquanto sua conta estiver ativa e por até 5 anos após o encerramento, para fins fiscais.</p>
            </div>

            <div>
              <h2 className="text-lg font-bold text-white mb-2">7. Seus Direitos (LGPD Art. 18)</h2>
              <ul className="list-disc pl-5 space-y-1">
                <li>Confirmar existência de tratamento</li>
                <li>Acessar seus dados</li>
                <li>Corrigir dados incompletos ou desatualizados</li>
                <li>Anonimizar, bloquear ou eliminar dados desnecessários</li>
                <li>Portar seus dados</li>
                <li>Eliminar dados tratados com consentimento</li>
                <li>Revogar o consentimento a qualquer momento</li>
              </ul>
              <p className="mt-2">Envie qualquer solicitação para <a className="text-red-500" href="mailto:edinaldoalvesdasilva8@gmail.com">edinaldoalvesdasilva8@gmail.com</a>. Responderemos em até 15 dias.</p>
            </div>

            <div>
              <h2 className="text-lg font-bold text-white mb-2">8. Segurança</h2>
              <p>Adotamos criptografia em trânsito (HTTPS), cookies httpOnly, autenticação JWT, hash bcrypt para senhas e princípio do menor privilégio.</p>
            </div>

            <div>
              <h2 className="text-lg font-bold text-white mb-2">9. Cookies</h2>
              <p>Usamos apenas cookies essenciais de autenticação (session token). Não usamos cookies de rastreamento publicitário.</p>
            </div>

            <div>
              <h2 className="text-lg font-bold text-white mb-2">10. Alterações</h2>
              <p>Podemos atualizar esta política. Alterações relevantes serão notificadas por email.</p>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
}
